import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
import axios from 'axios'
import VueMoment from 'vue-moment'
import moment from "moment"
import i18n from './i18n'
import CountryFlag from 'vue-country-flag'

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
moment.locale('de');

Vue.use(VueMoment, {
    moment,
});

Vue.component('country-flag', CountryFlag)

function tokenInterceptor() {
    axios.defaults.baseURL = "https://connect.woehr.de";
    axios.interceptors.request.use(config => {
        config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
        return config
    }, error => {
        return Promise.reject(error)
    })
}

Vue.use(VueKeycloakJs, {
    init: {
        onLoad: 'login-required'
    },
    config: {
        authRealm: 'woco',
        authUrl: 'https://auth.woehr.de/auth/',
        authClientId: 'woco-fe'
    },
    onReady: () => {
        tokenInterceptor();
        /* eslint-disable no-new */
        new Vue({
            router,
            vuetify,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app')
    }
});
